const kebabCase = (string) => {
	try {
		return string
			.replace(/^\s+|\s+$/g, "")
			.split(" ")
			.join("-")
			.toLowerCase();
	} catch (error) {
		return {};
	}
};

export default kebabCase;
